import { render, staticRenderFns } from "./AnimalWeightRecord.ResultRow.vue?vue&type=template&id=b6877f9e&"
import script from "./AnimalWeightRecord.ResultRow.vue?vue&type=script&lang=js&"
export * from "./AnimalWeightRecord.ResultRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports